export const maskEmail = (email: string): string => {
  if (!email) {
    return '';
  }

  const [localPart, domainPart] = email.split('@');

  if (!domainPart) {
    return maskSegment(localPart);
  }

  const domainSections = domainPart.split('.');

  if (domainSections.length === 0) {
    return `${maskSegment(localPart)}@`;
  }

  const [primaryDomain, ...restDomain] = domainSections;
  const maskedLocal = maskSegment(localPart);
  const maskedDomain = maskSegment(primaryDomain);
  const domainTail = restDomain.join('.');

  return domainTail ? `${maskedLocal}@${maskedDomain}.${domainTail}` : `${maskedLocal}@${maskedDomain}`;
};

const maskSegment = (segment: string): string => {
  if (!segment) {
    return '';
  }

  if (segment.length === 1) {
    return '*';
  }

  if (segment.length === 2) {
    return `${segment[0]}*`;
  }

  const maskedMiddle = '*'.repeat(Math.max(segment.length - 2, 1));

  return `${segment[0]}${maskedMiddle}${segment[segment.length - 1]}`;
};
